import React from "react";
import { Check, Pencil, X } from "react-bootstrap-icons";
import { CouponCode } from "../types";
import * as Styled from "./CouponCard.styled";

interface Props {
  coupon: CouponCode;
  onToggleStatus: (enabled: boolean) => void;
  onEditRedemptions: () => void;
}

const discountLabel = (coupon: CouponCode) =>
  coupon.type === "PERCENT"
    ? `${coupon.percentOff}% off`
    : `$${Number(coupon.amountOff || 0).toFixed(2)} off`;
const durationLabel = (coupon: CouponCode) =>
  coupon.duration === "REPEATING"
    ? `${coupon.durationInMonths} months`
    : coupon.duration.toLowerCase();

export const CouponCard: React.FC<Props> = ({ coupon, onToggleStatus, onEditRedemptions }) => (
  <Styled.Card>
    <Styled.LeftSection>
      <Styled.TitleRow>
        <Styled.Title>{coupon.code}</Styled.Title>
        <Styled.Badge $active={coupon.active}>{coupon.active ? "Active" : "Inactive"}</Styled.Badge>
      </Styled.TitleRow>
      <Styled.Subtitle>
        {coupon.name} · {discountLabel(coupon)} · {durationLabel(coupon)}
      </Styled.Subtitle>
    </Styled.LeftSection>
    <Styled.Metrics>
      <Styled.Metric>
        <Styled.MetricValue>
          {coupon.redemptionCount || 0} / {coupon.maxRedemptions || "∞"}
        </Styled.MetricValue>
        <Styled.MetricLabel>Redemptions</Styled.MetricLabel>
      </Styled.Metric>
      <Styled.Metric>
        <Styled.MetricValue>
          {coupon.appliesToAllPlans ? "All" : coupon.eligiblePlanIds.length}
        </Styled.MetricValue>
        <Styled.MetricLabel>Plans</Styled.MetricLabel>
      </Styled.Metric>
    </Styled.Metrics>
    <Styled.RightSection>
      <Styled.EditButton onClick={onEditRedemptions} title="Edit redemption limit">
        <Pencil />
      </Styled.EditButton>
      <Styled.ControlsWrapper>
        <Styled.ControlIndicator $isEnabled={coupon.active} />
        <Styled.ControlButton
          $isActive={!coupon.active}
          onClick={() => onToggleStatus(false)}
          title="Deactivate"
        >
          <X />
        </Styled.ControlButton>
        <Styled.ControlButton
          $isActive={coupon.active}
          onClick={() => onToggleStatus(true)}
          title="Activate"
        >
          <Check />
        </Styled.ControlButton>
      </Styled.ControlsWrapper>
    </Styled.RightSection>
  </Styled.Card>
);
